export const MAIL_CONSENTS_MOCK = {
    id: {
        bac_number: 'BAC_111_181_987_988',
    },
    consents: [
        {
            id: 'pensions',
            legitimate_interest: false,
            description: 'Alles rund um Riester, Rürup, bAV',
            name: 'Altersvorsorge',
            valid: false,
        },
        {
            id: 'savings',
            legitimate_interest: false,
            description: 'Neuigkeiten rund um Tages- und Festgeldangebote\t',
            name: 'Sparprodukte',
            valid: false,
        },
        {
            id: 'investments',
            legitimate_interest: false,
            description: 'Wissenswertes über Anlageportfolios, die Kapitalmärkte sowie Webinare und Bonusaktionen\t',
            name: 'Investmentprodukte',
            valid: false,
        },
        {
            id: 'beta_program',
            legitimate_interest: false,
            description: 'Beta-Programm',
            name: 'Beta Programm',
            valid: false,
        },
        {
            id: 'cs',
            legitimate_interest: true,
            description: 'Aktuelles zu Ihrem WeltSpar-Konto',
            name: 'Wichtige Informationen',
            valid: true,
        },
        {
            id: 'legal',
            legitimate_interest: true,
            description: 'Nicht abwählbare, verpflichtende Produkt- und Serviceinformationen bspw. Bestätigungen von Produkteröffnungen oder Stornierungen',
            name: 'Rechtliches',
            valid: true,
        },
    ],
};
//# sourceMappingURL=mail-consents.js.map